// TODO: How to make it to not need the /automation/engines and have paths relative in the module?
// This currently duplicates path in automation/helpers.tsx :(
export const basePath = `/automation/engines`;

export const newEnginePath = () => `${basePath}/new`;

export const engineBasicSettingsPath = (engineId: number) =>
  `${basePath}/${engineId}/settings/basic`;

export const engineQueueSettingsPath = (engineId: number) =>
  `${basePath}/${engineId}/settings/queues`;

export const ENGINE_ID_KEY = 'engineId';
// this route is deprecated, we just use it to redirect to the new one.
export const oldEngineDetailRoute = `${basePath}/:${ENGINE_ID_KEY}` as const;

export const engineBasicSettingsRoute =
  `${basePath}/:${ENGINE_ID_KEY}/settings/basic` as const;
export const engineQueueSettingsRoute =
  `${basePath}/:${ENGINE_ID_KEY}/settings/queues` as const;

export const engineNewRoute = `${basePath}/new` as const;

export const engineFieldDetailPath = (
  engineId: number,
  fieldId: number | 'new'
) => `${basePath}/${engineId}/fields/${fieldId}`;

export const engineFieldDetailRoute =
  `${basePath}/:${ENGINE_ID_KEY}/fields/:fieldId` as const;

export const engineFieldNewRoute =
  `${basePath}/:${ENGINE_ID_KEY}/fields/new` as const;
